import React from "react";

const VideoPreview = ({ data }) => {
  const videoRef = React.useRef(null);

  const handleMouseOver = () => {
    if (videoRef.current) {
      videoRef.current.play();
    }
  };

  const handleMouseOut = () => {
    if (videoRef.current) {
      videoRef.current.load();
    }
  };

  return (
    <video
      ref={videoRef}
      class="videoPreview"
      muted
      width="100%"
      height="100%"
      src={data.asset_original_url}
      poster={data.asset_thumbnail.replace(
        "gimscdn.maydream.com",
        "ims.maydream.com"
      )}
      onMouseOver={handleMouseOver}
      onMouseOut={handleMouseOut}
    />
  );
};

export default VideoPreview;
